const b62 = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
const b62ByChar  = {};
const b62ByValue = {};
const lzw = {};
const lzwByChar = {};

init();

export default {
  compress,
  decompress,
}

function init() {
  for (let i = 0; i < 62; i++) {
    let char = b62[i];
    let val  = (0o7 & i >> 3).toString() + (0o7 & i).toString();
    b62ByChar[char] = val;
    b62ByValue[val] = char;
  }

  for (let i = 0; i < 256; i++) {
    let char = String.fromCharCode(i);
    lzw[i] = char;
    lzwByChar[char] = i;
  }
}

function compress(text) {
  let result = compressLZW(text);
  result = deltaShrinkToBase8(result);
  result = base8to62(result);
  return result;
}

function decompress(compressed) {
  let result = base62to8(compressed);
  result = deltaUnshrinkFromBase8(result);
  result = decompressLZW(result);
  return result;
}

function compressLZW(text) {
  const byChar = Object.assign({}, lzwByChar);
  const result = [];
  let size = 256;
  let w = '';

  for (let i = 0; i < text.length; i++) {
    let c = text[i];
    let wc = w + c;

    if (wc in byChar) {
      w = wc;
    } else {
      result.push(byChar[w]);
      byChar[wc] = size++;
      w = c;
    }
  }

  if (w !== '') {
    result.push(byChar[w]);
  }
  return result;
}

function deltaShrinkToBase8(ints) {
  let base8 = [];
  let last = 0;
  for (let int of ints) {
    let k = int - last;
    base8.push(k.toString(6));
    last = int;
  }
  return base8.join('6').replace(/6-/g, '7');
}

function base8to62(base8) {
  base8 = base8.length % 2 ? '0' + base8 : '1' + base8 + '0';
  let base62 = '';
  for (let i = 0; i < base8.length; i+=2) {
    let chars = base8[i] + base8[i+1];
    base62 += b62ByValue[chars];
  }
  return base62;
}

function base62to8(base62) {
  if (!base62) {
    return '';
  }

  let base8 = '';
  for (let i = 0; i < base62.length; i++) {
    base8 += b62ByChar[base62[i]];
  }
  
  return base8[0] === '0' ? base8.substring(1) : base8.substring(1, base8.length - 1);
}

function deltaUnshrinkFromBase8(base8) {
  const ints = [];
  const comps = base8.replace(/7/g, '6-').split('6');
  let k = 0;

  for (let comp of comps) {
    k = k + parseInt(comp, 6);
    ints.push(k);
  }
  return ints;
}

function decompressLZW(compressed) {
  let dict = Object.assign({}, lzw);
  let dictSize = 256;
  let w = String.fromCharCode(compressed[0]);
  let result = w;

  for (let i = 1; i < compressed.length; i++) {
    let k = compressed[i];
    let entry = null;
    if (k in dict) {
      entry = dict[k];
    } else if (k === dictSize) {
      entry = w + w[0];
    } else {
      return null;
    }

    dict[dictSize++] = w + entry[0];
    w = entry;
    result += entry;
  }

  return result;
}
